import { authenticatedFetch } from "./dashboard-auth.js";
import type { PropertiesConveyorHealth } from "./dashboard-command-center.js";
import { propertiesConveyorHealthUrl, propertiesConveyorListUrl } from "./dashboard-urls.js";

let lastHealth: PropertiesConveyorHealth | null = null;

export type TreesPipelineListRow = {
  sp: string | null;
  street: string;
  city: string;
  county: string;
  owner: string;
};

export type TreesPipelineList = {
  stage: string;
  deadend: string | null;
  label: string;
  properties: TreesPipelineListRow[];
};

export function propertiesConveyorHealth(): PropertiesConveyorHealth | null {
  return lastHealth;
}

/** Compact D1 status. House lists load on demand via fetchPropertiesConveyorList. */
export async function fetchPropertiesConveyorHealth(): Promise<PropertiesConveyorHealth | null> {
  const response = await authenticatedFetch(propertiesConveyorHealthUrl);
  if (!response.ok) {
    lastHealth = null;
    return null;
  }
  lastHealth = await response.json() as PropertiesConveyorHealth;
  return lastHealth;
}

export async function fetchPropertiesConveyorList(stage: string, deadend: string | null): Promise<TreesPipelineList | null> {
  const params = new URLSearchParams({ stage });
  if (deadend) params.set("deadend", deadend);
  const response = await authenticatedFetch(`${propertiesConveyorListUrl}?${params}`);
  if (!response.ok) return null;
  return await response.json() as TreesPipelineList;
}
